import type { MessageId } from '@trust_network/shared/message-ids';

export interface ApiErrorPayload {
  messageId?: MessageId | string;
  message?: MessageId | string;
  issues?: {
    formErrors?: Array<MessageId | string>;
    fieldErrors?: Record<string, Array<MessageId | string> | undefined>;
  };
  statusCode?: number;
  transport?: {
    statusText: string;
    contentType?: string;
    bodyPreview?: string;
  };
}

export class ApiError extends Error {
  constructor(
    public readonly messageId: MessageId | string,
    public readonly status?: number,
    public readonly payload?: ApiErrorPayload
  ) {
    super(messageId);
  }
}
